document.addEventListener('DOMContentLoaded', function () {
  const defaultImageUrl = '//a-p-bloem-2.myshopify.com/cdn/shop/t/78/assets/bg-menu-default.svg';

  document.addEventListener('click', (e) => {
    if (!e.target.closest('.nav-item.dropdown')) {
      document.querySelectorAll('.nav-item.dropdown.show').forEach((item) => {
        item.classList.remove('show');
      });
    }
  });

  document.querySelectorAll('.nav-link.dropdown-toggle').forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const parentDropdown = link.parentElement;
      document.querySelectorAll('.nav-item.dropdown.show').forEach((item) => {
        if (item !== parentDropdown) item.classList.remove('show');
      });
      parentDropdown.classList.toggle('show');
    });
  });

  document.querySelectorAll('.dropdown-item img, .dropdown-item-nested img').forEach((img) => {
    if (img.src.includes('no-image')) {
      img.src = defaultImageUrl;
    }
  });

  const nestedSubmenuItems = document.querySelectorAll('.dropdown-item .nested-submenu .dropdown-item-nested');

  nestedSubmenuItems.forEach((item) => {
    const linkElement = item.querySelector('a');
    const imageElement = item.querySelector('.dropdown-item-image');

    if (linkElement && imageElement) {
      fetch(linkElement.href)
        .then((response) => response.text())
        .then((htmlContent) => {
          const doc = new DOMParser().parseFromString(htmlContent, 'text/html');
          const validImage = doc.querySelector('.details-services img');
          if (validImage?.src) imageElement.src = validImage.src;
        })
        .catch(() => {
          imageElement.src = defaultImageUrl;
        });
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const currentLang = document.documentElement.lang;
  const currentPath = window.location.pathname;
  const languageSwitcher = document.querySelector('.language-switcher2');
  const options = languageSwitcher.querySelectorAll('.language-option2');

  options.forEach((option) => {
    if (option.dataset.lang === currentLang) {
      option.style.display = 'none';
    } else {
      option.style.display = 'flex';
    }

    if (option.dataset.lang === 'en') {
      option.href = `/en${currentLang === 'nl' ? currentPath : currentPath.replace('/en', '')}`;
    } else if (option.dataset.lang === 'nl') {
      option.href = currentPath.replace('/en', '');
    }
  });
});
